import { Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const VoucherPaymentPageHeaderBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
});

export const VoucherPaymentTitleSection = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
});

export const VoucherPaymentBackButton = styled(IconButton)({
  width: '35px',
  height: '35px',
  backgroundColor: '#FFFFFF',
  border: '1px solid #DFDFDF',
  boxShadow: '0px 1px 3px rgba(0, 53, 114, 0.12)',
  borderRadius: '16px',
  '&:hover': {
    backgroundColor: '#F1F7FF',
  },
});

export const VoucherPaymentBackIcon = styled(Box)({
  fontSize: '20px',
  color: '#75838A',
});

export const VoucherPaymentPageTitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '28px',
  fontWeight: 600,
  color: 'var(--primary-blue)',
});

export const VoucherPaymentPageSubtitle = styled(Typography)({
  fontFamily: 'Outfit',
  fontSize: '22px',
  fontWeight: 500,
  color: '#75838A',
});

export const VoucherPaymentPrimaryActionButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  backgroundColor: 'var(--primary-blue)',
  color: 'var(--bg-color)',
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 600,
  padding: '8px 16px',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'var(--hover-blue)',
  },
});

export const VoucherPaymentButtonIcon = styled(Box)({
  fontSize: '20px',
});
